export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-comment-37f20cd8cd4cc283376668e179b51ff6.svg";